export default __webpack_public_path__ + "static/media/time.35819844.svg";